module.exports = __webpack_public_path__ + "static/design_parts_editor-bc17e07b94985e1c08637431dbc80aed.png";